import { LocaleService } from '@farris/ui-locale';
import { UploadFile, UploadStatus, FUploadFileExtend } from '../model';
import { FARRIS_UPLOADFILE_LOCALEDATA } from '../locale';
const isObject = value => typeof value === 'object' && value !== null;
const isArray = value => Array.isArray(value);
let localSerStorage=null;
// 暂时用不到
const deepCloneObject = (src) => {
    if (!isObject(src)) return src;
    const target = isArray(src) ? [] : {};
    for (const key in src) {
        if (!src.hasOwnProperty(key)) continue;
        const v = src[key];
        target[key] = v && isObject(v) ? deepCloneObject(v) : v;
    }
    return target;
}

const humanizeBytes = (bytes: number): string => {
    if (bytes === 0) {
        return '0 Byte';
    }

    const k = 1024;
    const sizes: string[] = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    const i: number = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}
const generateId = (): string => {
    return Math.random().toString(36).substring(7);
}
const makeUploadFile = (file: File, index: number): UploadFile => {
    return {
        fileIndex: index,
        id: generateId(),
        name: file.name,
        size: file.size,
        type: file.type,
        form: new FormData(),
        progress: {
            status: UploadStatus.Queue,
            data: {
                percentage: 0,
                speed: 0,
                speedHuman: `${humanizeBytes(0)}/s`,
                startTime: null,
                endTime: null,
                eta: null,
                etaHuman: null
            }
        },
        lastModifiedDate: new Date(file.lastModified),
        sub: undefined,
        nativeFile: file
    };
}

const allMineTypes = {
    '.pdf': 'application/pdf',
    '.gif': 'image/gif',
    '.png': 'image/png',
    '.txt': 'text/plain',
    '.htm': 'text/html',
    '.html': 'text/html',
    '.jpe': 'image/jpeg',
    '.jpeg': 'image/jpeg',
    '.jpg': 'image/jpeg',
    '.js': 'text/javascript,application/javascript',
    '.json': 'application/json',
    '.pps': 'application/vnd.ms-powerpoint',
    '.ppt': 'application/vnd.ms-powerpoint',
    '.doc': 'application/msword',
    '.xml': 'text/xml,application/xml',
    '.zip': 'aplication/zip',
    '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    '.wps': 'application/vnd.ms-works',
    '.3gpp': 'audio/3gpp, video/3gpp',
    '.ac3': 'audio/ac3',
    '.asf': 'allpication/vnd.ms-asf',
    '.au': 'audio/basic',
    '.css': 'text/css',
    '.csv': 'text/csv',
    '.dot': 'application/msword',
    '.dtd': 'application/xml-dtd',
    '.dwg': 'image/vnd.dwg',
    '.dxf': 'image/vnd.dxf',
    '.jp2': 'image/jp2',
    '.mp2': 'audio/mpeg, video/mpeg',
    '.mp3': ' audio/mpeg',
    '.mp4': 'audio/mp4, video/mp4',
    '.mpeg': 'video/mpeg',
    '.mpg': 'video/mpeg',
    '.mpp': 'application/vnd.ms-project',
    '.ogg': 'application/ogg, audio/ogg',
    '.pot': 'application/vnd.ms-powerpoint',
    '.rtf': 'application/rtf,text/rtf',
    '.svf': 'image/vnd.svf',
    '.tif': 'image/tiff',
    '.tiff': 'image/tiff',
    '.wdb': 'application/vnd.ms-works',
    '.xhtml': 'application/xhtml+xml',
    '.xlc': 'application/vnd.ms-excel',
    '.xlm': 'application/vnd.ms-excel',
    '.xls': 'application/vnd.ms-excel',
    '.xlt': 'application/vnd.ms-excel',
    '.xlw': 'application/vnd.ms-excel'
};
const findMineTypeBySuffix = (suffix: string): string => {
    if (allMineTypes.hasOwnProperty(suffix)) {
        return allMineTypes[suffix];
    }
    return '';
}

const changeUploadFileToFileExtend = (files: UploadFile[]): FUploadFileExtend[] => {
    // 如果是数组
    let result=[];
    files.forEach(file=>{
        let preExtend = { id: '', name: '', size: 0, type: '', extend: null, extendStatus: 0, extendHeaders: null } as FUploadFileExtend;
        for (let resultProp in preExtend) {
            let tempProp = resultProp.replace('extend', 'response');
            if (file.hasOwnProperty(tempProp)) {
                preExtend[resultProp] = file[tempProp];
            }
        }
        result.push(preExtend);
    });
    
    return result;
}
/**
 * 标记是否已处理多语言
 * 解决
 * 1、f-file-uploader.service.ts和f-file-preview.component.ts 构造函数中没有引入多语言，
 * 要支持多语言就必须重新编译的问题
 * 2、引入通用处理的类，在类中进行保存服务
 */
const getLocalState=(localSer:LocaleService)=>{
    if(localSerStorage){
        return true;
    }
    if(localSer&&!localSerStorage){
            localSer.setLocaleData(FARRIS_UPLOADFILE_LOCALEDATA);
            localSerStorage=localSer;
            return true;
    }
    return false;
}
/**
 * 替换字符串
 * @param value 
 * @param args 
 * @returns 
 */
const  replaceStr=(value: any, ...args: any[]):string =>{
    args.forEach((v, i) => {
        value = value.replace(`{${i}}`, v);
    });
    return value;
}
/**
 * 获取多语言数据
 * 某些组件没有重新生成，要支持多语言
 * @param key 
 * @param replaceInfo 
 */
const getLocalStr=(lanKey:string,replaceInfo:Array<string>=[])=>{
    let result="";
    let defaultLocalId='zh-CHS';
    if(localSerStorage){
        result=localSerStorage.getValue(lanKey);
    }else{
        defaultLocalId= localStorage.getItem('languageCode')||'zh-CHS';
    }
    if(!result){
    //说明前面的语言环境没有取到
        result = lanKey.split('.').reduce((obj, key) => {
            if (obj) {
                return obj[key];
            } else {
                return null;
            }
        }, FARRIS_UPLOADFILE_LOCALEDATA[defaultLocalId]);
    }
    if(result&&replaceInfo.length>0){
        return replaceStr(result,replaceInfo);
    }
    return result;
}


export const FFileUtils = {
    isObject,
    isArray,
    deepCloneObject,
    humanizeBytes,
    makeUploadFile,
    findMineTypeBySuffix,
    changeUploadFileToFileExtend,
    getLocalState,
    getLocalStr
}